import React, { memo } from 'react';
import logoFile from "@/public/image/logo.svg";
import Image from 'next/image';

const Logo = memo(({ className = "" }) => {
  return (
    <Image 
      src={logoFile} 
      alt="Smart Bath Room Logo" 
      width={145}
      height={44}
      className={className}
      loading="eager"
      fetchPriority="auto"
    />
  );
});

Logo.displayName = 'Logo';

export default Logo;